enum DraftEntityTypes {
  Collections = "collections",
  Flows = "flows",
  Videos = "videoAssets",
  Emails = "emails",
  Messages = "messages",
  Assessments = "assessments",
  Campaigns = "threat-defence/campaigns",
  Surveys = "surveys",
  Packs = "packs",
  Events = "externalevents",
  Pdfs = "pdfs",
  EmbeddedVideos = "embeddedVideos",
  Links = "links",
  SCORM = "scorm",
}
export default DraftEntityTypes;
